/**
 * Api Documentation
 * Api Documentation
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import {
    HttpClient, HttpHeaders, HttpParams,
    HttpResponse, HttpEvent
} from '@angular/common/http';
import { CustomHttpUrlEncodingCodec } from '../encoder';

import { Observable } from 'rxjs';

import { DrugDto } from '../model/drugDto';

import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { Configuration } from '../configuration';


@Injectable()
export class DrugsService {

    protected basePath = 'https://fidcaresvil.kiranet.it/api/atm';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * findAbstractDrugs
     * Find all the abstract drugs starting with the passed string
     * @param name name
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public findAbstractDrugs(name: string, observe?: 'body', reportProgress?: boolean): Observable<Array<DrugDto>>;
    public findAbstractDrugs(name: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<DrugDto>>>;
    public findAbstractDrugs(name: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<DrugDto>>>;
    public findAbstractDrugs(name: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (name === null || name === undefined) {
            throw new Error('Required parameter name was null or undefined when calling findAbstractDrugs.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Array<DrugDto>>(`${this.basePath}/drugs/abstract/${encodeURIComponent(String(name))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * findCommercialDrugs
     * Find all the commercial drugs starting with the passed string
     * @param name name
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public findCommercialDrugs(name: string, observe?: 'body', reportProgress?: boolean): Observable<Array<DrugDto>>;
    public findCommercialDrugs(name: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<DrugDto>>>;
    public findCommercialDrugs(name: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<DrugDto>>>;
    public findCommercialDrugs(name: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (name === null || name === undefined) {
            throw new Error('Required parameter name was null or undefined when calling findCommercialDrugs.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Array<DrugDto>>(`${this.basePath}/drugs/commercial/${encodeURIComponent(String(name))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * findRelatedAbstractDrugs
     * Find the list of abstract drugs related to a commercial one, passed as UUID.
     * @param uuid uuid
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public findRelatedAbstractDrugs(uuid: string, observe?: 'body', reportProgress?: boolean): Observable<Array<DrugDto>>;
    public findRelatedAbstractDrugs(uuid: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<DrugDto>>>;
    public findRelatedAbstractDrugs(uuid: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<DrugDto>>>;
    public findRelatedAbstractDrugs(uuid: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (uuid === null || uuid === undefined) {
            throw new Error('Required parameter uuid was null or undefined when calling findRelatedAbstractDrugs.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Array<DrugDto>>(`${this.basePath}/drugs/abstracts/from/${encodeURIComponent(String(uuid))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * findRelatedCommercialDrugs
     * Find the list of commercial drugs related to the an abstract one, passed as UUID
     * @param uuid uuid
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public findRelatedCommercialDrugs(uuid: string, observe?: 'body', reportProgress?: boolean): Observable<Array<DrugDto>>;
    public findRelatedCommercialDrugs(uuid: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<DrugDto>>>;
    public findRelatedCommercialDrugs(uuid: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<DrugDto>>>;
    public findRelatedCommercialDrugs(uuid: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (uuid === null || uuid === undefined) {
            throw new Error('Required parameter uuid was null or undefined when calling findRelatedCommercialDrugs.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Array<DrugDto>>(`${this.basePath}/drugs/commercials/from/${encodeURIComponent(String(uuid))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
